import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state() {
    const initOptions = {
      chargeType: '',
      conbiniCode: '',
    };
    return {
      cardInfo: null,
      bankCardInfo: null,
      moneyNum: 0,
      chargeOptions: JSON.parse(sessionStorage.getItem('CHARGE_OPTIONS')) || initOptions,
      deleteCardStatus: false,
      bankList: [],
    };
  },
  mutations,
  actions,
  getters,
  namespaced: true
};
